module.exports = "/src/views/games/other/images/maps/map_0.png";